import { useEffect, useState } from "react";
import Aside from "../../components/aside/aside.component";
import Header from "../../components/header/header.component";
import Footer from "../../components/footer/footer.component";
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";
import { Link, useLocation } from "react-router-dom";

declare const KTComponents: any;

function FormRegisterPage() {
  const [step, setStep] = useState(1);
  const [corte, setCorte] = useState<any>(null);

  const { state } = useLocation();

  useEffect(() => {
    if (state && state.corte) {
      setCorte(state.corte);
    }
    if (state && state.step) {
      setStep(state.step);
    }
  }, [state]);

  useEffect(() => {
    KTComponents.init();
  }, [step]);

  // useEffect(() => {
  //   if(corte) {
  //     if(corte.packing) {
  //       setStep(3);
  //     } else {
  //       setStep(2);
  //     }
  //   }
  // }, [corte]);

  return (
    <>
      <div className="d-flex flex-column flex-root">
        <div className="page d-flex flex-row flex-column-fluid">
          <Aside />
          <div
            className="wrapper d-flex flex-column flex-row-fluid"
            id="kt_wrapper"
          >
            <Header />
            <div
              className="content fs-6 d-flex flex-column flex-column-fluid"
              id="kt_content"
            >
              <div className="toolbar">
                <div className="container-fluid d-flex flex-stack flex-wrap flex-sm-nowrap">
                  <div className="d-flex flex-column align-items-start justify-content-center flex-wrap me-2">
                    <h1 className="text-gray-900 fw-bold my-1 fs-2">
                      Cortes
                      <small className="text-muted fs-6 fw-normal ms-1" />
                    </h1>
                    <ul className="breadcrumb fw-semibold fs-base my-1">
                      <li className="breadcrumb-item text-muted">Operación</li>
                      <li className="breadcrumb-item text-gray-900">Cortes</li>
                    </ul>
                  </div>
                  <div className="d-flex align-items-center flex-nowrap text-nowrap py-1">
                    <Link className="btn btn-secondary" to={".."}>
                      <i className="ki-duotone ki-left"></i> Regresar
                    </Link>
                  </div>
                </div>
              </div>

              <div className="post fs-6 d-flex flex-column-fluid" id="kt_post">
                <div className="container-xxl">
                  <div className="card">
                    <div className="card-body">
                      <div
                        className="stepper stepper-links d-flex flex-column pt-15"
                        data-kt-stepper="true"
                      >
                        <div className="stepper-nav mb-5">
                          <div
                            className={`stepper-item ${
                              step === 1 ? "current" : ""
                            } ${corte?._id ? "" : ""}`}
                          >
                            <h3 className="stepper-title">General</h3>
                          </div>
                          <div
                            className={`stepper-item ${
                              step === 2 ? "current" : ""
                            } ${corte?._id ? "" : ""}`}
                          >
                            <h3 className="stepper-title">Empaque</h3>
                          </div>
                          <div
                            className={`stepper-item ${
                              step === 3 ? "current" : ""
                            } ${corte?._id ? "" : ""}`}
                          >
                            <h3 className="stepper-title">Pago</h3>
                          </div>
                        </div>

                        {step === 1 && (
                          <Step1 corte={corte} next={() => setStep(2)} />
                        )}
                        {step === 2 && (
                          <Step2
                            corte={corte}
                            prev={() => setStep(1)}
                            next={() => setStep(3)}
                          />
                        )}
                        {step === 3 && (
                          <Step3 corte={corte} prev={() => setStep(2)} />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default FormRegisterPage;
